import { SortDirection, TableSort } from "@redotech/redo-views-common/table";
import {
  DEFAULT_PAGE_SIZE,
  viewTypes,
} from "@redotech/redo-views-common/views";

export enum ReplenishmentRequestSystemView {
  ALL = "all",
  CREATE = "create",
}

const sortDefault: TableSort = {
  direction: SortDirection.ASC,
  key: "createdAt",
};

const defaultColumns = [
  { key: "sku", width: 150, hidden: false },
  { key: "productTitle", width: 250, hidden: false },
  { key: "binName", width: 140, hidden: false },
  { key: "sourceBinName", width: 140, hidden: false },
  { key: "status", width: 120, hidden: false },
  { key: "createdAt", width: 180, hidden: false },
  { key: "note", width: 200, hidden: false },
];

export const StaticSystemViews: Record<
  Exclude<
    ReplenishmentRequestSystemView,
    ReplenishmentRequestSystemView.CREATE
  >,
  viewTypes["replenishment-requests"]
> = {
  [ReplenishmentRequestSystemView.ALL]: {
    table: "replenishment-requests",
    name: ReplenishmentRequestSystemView.ALL,
    filters: [],
    columns: defaultColumns,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: sortDefault,
    position: 0,
  },
};

const FRIENDLY_NAMES: Record<string, string> = {
  [ReplenishmentRequestSystemView.ALL]: "All requests",
};

export function friendlyViewName(view: viewTypes["replenishment-requests"]) {
  return FRIENDLY_NAMES[view.name] ?? view.name;
}
